@for (sep of labelSep; track sep; let i = $index) {
  <span [ngClass]='{"italic": sepValue[i].indexOf("TRANS__") === 0}'>
    {{sep}}
  </span>
}

